<template>
  <div class="map-projection-view">
    <div
      v-for="option in options"
      :key="option.key"
      class="projection-row"
      @click="select(option.key)"
    >
      <div class="flex-grow-1">
        <div class="projection-name">{{ option.label }}</div>
        <div class="projection-desc">{{ option.description }}</div>
      </div>
      <span v-if="current === option.key" class="material-icons check-icon">check</span>
    </div>

    <div class="px-3 pt-3">
      <button class="reset-btn" @click="resetToDefault">{{ $t('shared.reset_to_default') }}</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getMapSettings, saveMapSettings, MapProjection } from '../../../utils/mapSettings';

export default defineComponent({
  name: 'MapProjectionView',

  props: {
    mapInstanceName: { type: String, default: 'map' },
  },

  data() {
    return {
      current: getMapSettings().projection as MapProjection,
    };
  },

  computed: {
    options(): { key: MapProjection; label: string; description: string }[] {
      return [
        {
          key: 'globe' as MapProjection,
          label: this.$t('base_map_dialog.map_projection_view.globe'),
          description: this.$t('base_map_dialog.map_projection_view.spherical_globe_view'),
        },
        {
          key: 'mercator' as MapProjection,
          // Proper name of the projection — not translated.
          label: 'Mercator',
          description: this.$t('base_map_dialog.map_projection_view.standard_flat_map_projection'),
        },
      ];
    },
  },

  methods: {
    select(projection: MapProjection) {
      this.current = projection;
      const settings = getMapSettings();
      settings.projection = projection;
      saveMapSettings(settings);
      try {
        const map = (window as Record<string, any>)[this.mapInstanceName];
        if (map) map.setProjection(projection);
      } catch {}
    },
    resetToDefault() {
      this.select('globe');
    },
  },
});
</script>

<style scoped>
.map-projection-view {
  padding-bottom: 24px;
}

.projection-row {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #2e2e2e;
  cursor: pointer;
  transition: background 0.15s;
}

.projection-row:last-child {
  border-bottom: none;
}

.projection-row:hover {
  background: rgba(255, 255, 255, 0.04);
}

.projection-name {
  font-size: 0.95rem;
  font-weight: 500;
}

.projection-desc {
  font-size: 0.78rem;
  color: #888;
  margin-top: 2px;
}

.check-icon {
  color: #fddf00;
  flex-shrink: 0;
}

.reset-btn {
  width: 100%;
  padding: 12px;
  background: #2d2d2d;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.reset-btn:hover {
  background: #3a3a3a;
}
</style>
